import { useNavigate } from "react-router-dom"
import "../styles/portal/TrabalhoDetalhe.css";
import { useContext, useEffect, useRef, useState } from "react";
import { PortalContext } from "../Portal";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  Polygon,
} from "@react-google-maps/api";
import { downloadFile, readShapefiles } from "../aws/Authentication";
import Legenda from "./Legenda";
import html2canvas from "html2canvas";
import { deleteEventAPI } from "../aws/Api";
import Botao from "../utils/Botao";
import { criaArrayPoligonosUnificado, criaArrayPoligonosUnificadoFundido, organizaShape } from "./processadorPoligonos.worker";
const libraries = ["places"];
const mapContainerStyle = {
  flex: "1",
  "align-self": "center",
//   "max-width": "800px",
//   "max-height": "1000px",
    height: "600px",
};


function TrabalhoDetalhe() {
    const { user, campoEscolhido, eventoEscolhido, setShpData, setShxData, setDbfData, dbfData, shpData, identityId } = useContext(PortalContext);
    const [coluna, setColuna] = useState(0);    
    const [path, setPath] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("");
    const [defaultCenter, setCenter] = useState({
        lat: (campoEscolhido ? parseFloat(campoEscolhido.latRef) : 0),
        lng: (campoEscolhido ? parseFloat(campoEscolhido.lonRef) : 0),
    });
    const [loadingPDF, setLoadingPDF] = useState(false);
    const navigate = useNavigate();
    const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_MAPS_JS_KEY
    const GOOGLE_STATIC_KEY = process.env.REACT_APP_GOOGLE_STATIC_MAPS_KEY
    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: GOOGLE_KEY,
        libraries,
    });
    const mapRef = useRef(null);
    const mapaContainerRef = useRef(null);
    const onLoad = (map) => {
        mapRef.current = map;
        // console.log("Chamou onLoad");
    };

    /* useEffect(() => {
        //Carregou o componente ou alterou a coluna. 
        // Primeiro precisa instanciar o worker
        console.log("início do useEffect");
        const worker = new Worker(new URL('./processadorPoligonos.worker.js', import.meta.url));

        // Verifica se tem o objeto shpData e dbfData
        if (!shpData && !dbfData) {
            // Ainda nao tem, entao busca
            console.log("Não tem shpData, vai buscar");
            setLoading(true);
            setLoadingMessage("Baixando arquivos...");

            Promise.all([
            readShapefiles(eventoEscolhido.eventoUUID + ".shp"),
            readShapefiles(eventoEscolhido.eventoUUID + ".shx"),
            readShapefiles(eventoEscolhido.eventoUUID + ".dbf"),
            ])
            .then(([shpSignedURL, shxSignedURL, dbfSignedURL]) =>
                Promise.all([
                shpSignedURL.Body.arrayBuffer(),
                shxSignedURL.Body.arrayBuffer(),
                dbfSignedURL.Body.arrayBuffer(),
                ])
            )
            .then(([shpBinary, shxBinary, dbfBinary]) => {
                setLoadingMessage("Processando dados (aguarde)...");
                console.log("Finalizou de buscar todos, posta  um worker com shpBinary = ", shpBinary, ", shxBinary=", shxBinary, ", dbfBinary=", dbfBinary, ", coluna=", coluna);
                worker.postMessage({ shpBinary, shxBinary, dbfBinary, coluna });
            })
            .catch((error) => {
                console.error("Erro ao buscar arquivos:", error);
                setLoading(false);
                setLoadingMessage("Erro ao carregar arquivos.");
            });
        } 
        else {
            // Se ja fez o download antes, entao ja tem o dbfData apenas reprocesse para a nova coluna
            console.log("Colocando no post do worker já baixado shpData=", shpData, ", dbfData=", dbfData, ", coluna=", coluna);
            worker.postMessage({ shpData, dbfData, coluna });
        }

        //Funcao de callback quando retornar a msg do worker
        worker.onmessage = (e) => {
            const { status, data, message, shpObj, dbfObj } = e.data;
            console.log("Retorno do worker, com status=", status, ", data=", data, ", message=", message, ", shpObj=", shpObj, ", dbfObj=", dbfObj);
            if (status === 'success') {
                if (!dbfData) {
                    console.log("success com !dbfData");
                    setShpData(shpObj);
                    setDbfData(dbfObj);  // se você realmente precisar guardar para reuso
                    setCenter({
                        lat: shpObj.boxYmin + (shpObj.boxYmax - shpObj.boxYmin) / 2,
                        lng: shpObj.boxXmin + (shpObj.boxXmax - shpObj.boxXmin) / 2,
                    });
                }
                else {
                    console.log("success com dbfData");
                    setCenter({
                        lat: shpData.boxYmin + (shpData.boxYmax - shpData.boxYmin) / 2,
                        lng: shpData.boxXmin + (shpData.boxXmax - shpData.boxXmin) / 2,
                    });
                }
                setPath(data);
                setLoading(false);
                setLoadingMessage('');              
            } 
            else if (status === 'error') {
                console.error("status = error no Web Worker:", message);
                // setLoading(false);
                setLoadingMessage("Erro ao processar o arquivo.");
            }
        };

        worker.onerror = (error) => {
            console.error("Erro no Web Worker:", error);
            // setLoading(false);
            setLoadingMessage("Erro inesperado no processamento.");
        };

        // limpeza
        return () => worker.terminate();
    }, [dbfData, coluna]); */

    useEffect(() => {
        // console.log("início do useEffect com lat lon ref = ", parseFloat(campoEscolhido.latRef), ", ", parseFloat(campoEscolhido.lonRef));

        async function processar() {
            try {
                // Verifica se já existe shpData/dbfData
                if (!shpData && !dbfData) {
                    // console.log("Não tem shpData, vai buscar");
                    setLoading(true);
                    setLoadingMessage("Baixando arquivos...");

                    // 1) Baixar arquivos
                    const [shpSignedURL, shxSignedURL, dbfSignedURL] = await Promise.all([
                        readShapefiles(eventoEscolhido.eventoUUID + ".shp"),
                        readShapefiles(eventoEscolhido.eventoUUID + ".shx"),
                        readShapefiles(eventoEscolhido.eventoUUID + ".dbf"),
                    ]);

                    const [shpBinary, shxBinary, dbfBinary] = await Promise.all([
                        shpSignedURL.Body.arrayBuffer(),
                        shxSignedURL.Body.arrayBuffer(),
                        dbfSignedURL.Body.arrayBuffer(),
                    ]);

                    // 2) Processar binários
                    setLoadingMessage("Processando dados (aguarde)...");
                    await new Promise(r => setTimeout(r, 10)); // garante repaint do overlay

                    const { shpObj, dbfObj } = organizaShape(shpBinary, shxBinary, dbfBinary);
                    // console.log("shpObj = ", shpObj, ", dbfObj = ", dbfObj);
                    // 3) Criar polígonos da coluna escolhida
                    const data = criaArrayPoligonosUnificadoFundido(shpObj, dbfObj, coluna);

                    // 4) Atualizar estados
                    setShpData(shpObj);
                    setDbfData(dbfObj);
                    setCenter({
                        lat: shpObj.boxYmin + (shpObj.boxYmax - shpObj.boxYmin) / 2,
                        lng: shpObj.boxXmin + (shpObj.boxXmax - shpObj.boxXmin) / 2,
                    });
                    setPath(data);

                    setLoading(false);
                    setLoadingMessage('');
                } 
                else {
                    // Já tem os dados baixados → só reprocesa a coluna
                    // console.log("Reprocessando coluna com dados já em memória");
                    setLoading(true);
                    setLoadingMessage("Atualizando visualização com " + dbfData.numOfRecords + " polígonos");
                    await new Promise(r => setTimeout(r, 100));

                    // const dataAntes = criaArrayPoligonosUnificado(shpData, dbfData, coluna);
                    // console.log("Resultado do criaArrayPoligonosUnificado = ", dataAntes);
                    let tolerancia = 0; // percentual de tolerancia usado para fundir poligonos
                    if (coluna === 2)
                        tolerancia = 3; // Como a velocidade ´e baixa e muda muito ap´os a virgula, colocamos uma tolerancia de 3¢
                    const data = criaArrayPoligonosUnificadoFundido(shpData, dbfData, coluna, tolerancia);
                    // console.log("Resultado do criaArrayPoligonosUnificadoFundido = ", data);
                    setCenter({
                        lat: shpData.boxYmin + (shpData.boxYmax - shpData.boxYmin) / 2,
                        lng: shpData.boxXmin + (shpData.boxXmax - shpData.boxXmin) / 2,
                    });
                    setPath(data);

                    setLoading(false);
                    setLoadingMessage('');
                }
            } catch (error) {
                console.error("Erro ao processar:", error);
                setLoading(true);
                setLoadingMessage("Erro ao carregar/processar arquivos: " + error);
            }
        }

        processar();
    }, [dbfData, coluna]);

    
    if (loadError) {
        return <div>Error loading maps</div>;
    }

    if (!isLoaded) {
        return <div>Loading maps</div>;
    }
    const handleOnClickVoltar = () => {
        navigate("/portal/trabalhos");
        setDbfData(null);
        setShpData(null);
    }

    function handleDownloadShape(fileKey, filename) {
        // console.log("Clicou para baixar");
        downloadFile(fileKey + ".dbf", filename + ".dbf")
        .then((data) => {
            downloadFile(fileKey + ".shp", filename + ".shp")
            .then((data) => {
                downloadFile(fileKey + ".shx", filename + ".shx").catch((err) =>
                console.log(err)
                );
            })
            .catch((err) => console.log(err));
        })
        .catch((err) => console.log(err));
    }

    const capturarMapa = async () => {
        // console.log("📌 capturarMapa chamado...");

        if (!mapRef.current) {
            console.error("❌ mapRef.current está nulo!");
            return;
        }
        // console.log("✅ mapRef.current encontrado:", mapRef.current);

        // Pequeno delay para garantir que os tiles carregaram
        setTimeout(async () => {
            // console.log("🎥 Iniciando html2canvas...");
            const isMobile = /Mobi|Android/i.test(navigator.userAgent);

            const mapa = mapaContainerRef.current;
            const originalWidth = mapa.style.width;
            const originalHeight = mapa.style.height;

            // aumenta tamanho só para captura
            mapa.style.width = "1000px";
            mapa.style.height = "1000px";

            await new Promise(r => setTimeout(r, 300)); // espera redesenho
            
            const canvas = await html2canvas(mapa, {
                useCORS: true,
                // logging: true, // ativa logs internos do html2canvas
                scale: isMobile ? 1 : 1.0, // só aumenta a resolução em desktop

            });

            mapa.style.width = originalWidth;
            mapa.style.height = originalHeight;

            // console.log("✅ html2canvas finalizado:", canvas);

            const dataURL = canvas.toDataURL("image/png", 0.7); 
            
            // console.log("📏 Tamanho do dataURL:", dataURL?.length || 0);
            // console.log("🔍 Preview dataURL:", dataURL?.substring(0, 200));

            setLoadingPDF(true);

            try {
                const response = await fetch("https://u7qgkus084.execute-api.us-east-2.amazonaws.com/dev/gerar_relatorio", {// "http://localhost:5000/gerar-relatorio", {
                //const response = await fetch("http://localhost:5000/gerar-relatorio", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                    dados: {
                        usuario: user.attributes.name,
                        campo: campoEscolhido.value,
                        produto: eventoEscolhido.eventoNome,
                        quantidade: eventoEscolhido.produtoAplicado,
                        area: eventoEscolhido.areaAplicadaTotal,
                        tempo: eventoEscolhido.tempoTotal,
                        velocidade: eventoEscolhido.velMedia,
                        transpasse: eventoEscolhido.transpasse,
                        taxa: eventoEscolhido.taxaFixa ? "Taxa Fixa" : "Taxa Variável",
                        data: eventoEscolhido.data,
                    },
                    imagemMapa: dataURL,
                    }),
                });
                if (response.ok) {
                    const data = await response.json();
                    // console.log("data.url = ", data.url);

                    if (data.url) {
                        try {
                            // Baixa o PDF em background
                            /* const pdfResponse = await fetch(data.url);
                            if (!pdfResponse.ok) throw new Error("Erro ao buscar PDF no S3");

                            const blob = await pdfResponse.blob();
                            const url = window.URL.createObjectURL(blob);

                            // Cria link invisível para baixar
                            const a = document.createElement("a");
                            a.href = url;
                            a.download = "relatorio.pdf"; // nome fixo, pode personalizar
                            a.click();

                            window.URL.revokeObjectURL(url); 
                            console.log("✅ PDF baixado sem sair do app"); */
                            // abre direto em nova aba/janela
                            window.open(data.url, "_blank");
                            // console.log("✅ PDF aberto em nova aba");
                        } catch (err) {
                            // console.error("❌ Falha ao baixar PDF:", err);
                        }
                    }/*  else {
                        console.error("❌ URL presign não recebida");
                    } */
                } /* else {
                    console.error("❌ Erro na resposta do backend:", response.status);
                } */
            } catch (err) {
                // cosnsole.error("❌ Erro no download:", err);
            } finally {
                setLoadingPDF(false);
            }



            // const { url } = await response.json();
            // window.open(url, "_blank"); // abre PDF direto  
        }, 500);
    };
    

    const handleDelete = async () => {
        const confirmacao = window.confirm(
            "Tem certeza que deseja apagar este evento?"
        );

        if (!confirmacao) {
            // console.log("pressionou nao");
            console.log("Identity id = ", identityId);
            return;
        }

        // console.log("pressionou sim");
        if (!identityId)
            return;

        try {
            deleteEventAPI(campoEscolhido.value, eventoEscolhido.eventoUUID, identityId).then(res => {
                if(!res.ok) throw Error("Não conseguiu buscar");
                return res.json();
            }).then(data => {
                // console.log("Retorno do delete events ", data);
                alert("Evento excluído com sucesso!");
                handleOnClickVoltar();
            }).catch(err => {
                // console.log("Catch do TrabalhoDetalhe Depois de pedir pra deletar evento ", err);
            });
            //onDelete(evento.id); // Atualiza a lista no front
        } catch (error) {
            // console.error("Erro:", error);
            alert("Falha ao excluir o evento.");
        }        
    };
    const botoesStyle = {
        width: "120px", 
        height: "50px", 
        "font-weight": "normal"
    }
    return (
        <div className="trabalhos-main-container">
            <div className="trabalhos-tittle-container">
                <Botao handleOnClick={() => handleOnClickVoltar()} estilo={{width: "100px", height: "50px"}}>Voltar</Botao>
                {/* <button className="trabalhos-tittle-btnvoltar" onClick={() => handleOnClickVoltar()}>Voltar</button> */}
                <div className="tittle">Detalhe Evento {eventoEscolhido.eventoNome}</div>
            </div>
            <div className="trabalho-detalhe-content-container">
                <div className="trabalho-detalhe-dados-container">
                    <div className="trabalho-detalhe-dado">
                        <p>Área aplicada:</p>
                        <h3>{eventoEscolhido.areaAplicadaTotal} ha</h3>
                    </div>
                    <div className="trabalho-detalhe-dado">
                        <p>Produto Aplicado:</p>
                        <h3>{eventoEscolhido.produtoAplicado} kgs</h3>
                    </div>
                    <div className="trabalho-detalhe-dado">
                        <p>Taxa:</p>
                        <h3>{eventoEscolhido.taxaFixa ? "Taxa Fixa" : "Taxa Variável"}</h3>
                    </div>
                    <div className="trabalho-detalhe-dado">
                        <p>Tempo total:</p>
                        <h3 style={{"font-size" : "1em"}}>{eventoEscolhido.tempoTotal}</h3>
                    </div>
                    <div className="trabalho-detalhe-dado">
                        <p>Transpasse:</p>
                        <h3>{eventoEscolhido.transpasse} ha</h3>
                    </div>
                    <div className="trabalho-detalhe-dado">
                        <p>Velocidade Média:</p>
                        <h3>{eventoEscolhido.velMedia} km/h</h3>
                    </div>
                </div>
                <div className="trabalho-detalhe-btns-container">
                    <div className="trabalho-detalhe-mapa-coluna">
                        <label>Coluna:</label>
                        <select value={coluna} onChange={(e) => {
                            const v = parseInt(e.target.value, 10); // converte mesmo que venha "0"
                            setColuna(Number.isNaN(v) ? 0 : v);     // fallback seguro
                        }}>
                            {dbfData && dbfData.records.map((coluna) => (
                                <option value={coluna.index}>{coluna.nomeColuna}</option>
                            ))}
                        </select>
                    </div>
                    <Botao 
                        handleOnClick={() => handleDownloadShape(eventoEscolhido.eventoUUID, `-${eventoEscolhido.eventoNome}`)}
                        estilo={botoesStyle}
                    >
                        Baixar Shape
                    </Botao>
                    <Botao handleOnClick={capturarMapa} estilo={botoesStyle}>
                        {loadingPDF ? "Gerando relatório..." : "Baixar Relatório"}
                    </Botao>
                    {/* <button onClick={() => handleDownloadShape(eventoEscolhido.eventoUUID, `-${eventoEscolhido.eventoNome}`)}>Baixar Mapa</button> */}
                    {/* <button onClick={capturarMapa} disabled={loadingPDF}>
                        {loadingPDF ? "Gerando relatório..." : "Baixar Relatório"}
                    </button> */}
                    {loadingPDF && <p>Aguarde, estamos gerando seu relatório PDF...</p>}
                    <Botao handleOnClick={handleDelete} estilo={botoesStyle}>Excluir Evento</Botao>
                    {/* <button onClick={handleDelete}>Excluir Evento</button> */}
                </div>
                <div className="trabalho-detalhe-mapa-container" ref={mapaContainerRef}>
                    {/* <h3>oi</h3> */}
                    {loading && <h3 style={{"justifySelf": "center"}}>{loadingMessage}</h3>}
                    <GoogleMap
                        mapContainerStyle={mapContainerStyle}
                        zoom={15}
                        center={defaultCenter} // É bom ter uma propriedade de centro definida
                        mapTypeId="satellite"
                        onLoad={onLoad} // aqui vinculamos o mapa ao ref
                    >
                        {path.length > 0 && path.map((poligono, index) => (
                            <Polygon
                            key={index}
                            path={poligono.points}
                            options={{
                                fillColor: poligono.rgb,
                                strokeWeight: 0,
                                fillOpacity: 0.7,
                            }}
                            />
                        ))}
                        <Marker
                            position={path[0]?.points[0]}
                        />
                    </GoogleMap>
                    {dbfData && (coluna === 0 ? <Legenda tipo="taxa" min={dbfData.limites[1].limiteMin} max={dbfData.limites[1].limiteMax} maxAplicado={dbfData.limites[0].limiteMax} /> 
                        : <Legenda tipo="generic" min={dbfData.limites[coluna].limiteMin} max={dbfData.limites[coluna].limiteMax} />) }
                    {/* <Legenda tipo="generic" min={0} max={100} /> */}
                    {/* <Legenda tipo="taxa" min={100} max={500} maxAplicado={1000} /> */}
                    {/* <LegendaBarra tipo="generic" min={0} max={100} /> */}
                    {/* <LegendaBarra tipo="taxa" min={100} max={500} maxAplicado={1000} /> */}
                </div>
            </div>
        </div>
    )
}

export default TrabalhoDetalhe
